export default {
  labels: {
    general: 'פרטי מערכת',
    version: 'גירסת מערכת',
    environment: 'סביבה',
  },
};
